import React from 'react';
export function MatrixE1Section() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1373">
      <div className="flex flex-col md:flex-row" data-id="element-1374">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1375">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Matrix%20E1.png" alt="MATRIX E1" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1376" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1377">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1378">
            MATRIX E1
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1379">
            High-Dynamic and High-Precision 5-axis Monoblock Vertical Gantry
            Machining Center
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1380">
            <p className="leading-relaxed" data-id="element-1381">
              Available in various configurations to provide a perfect answer to
              the needs of specific applications, including molds and dies,
              aerostructures, and composite materials machining. This machine is
              ideal for hi-feed{' '}
              <strong data-id="element-1382">
                roughing, semi-finishing and finishing of medium-size workpieces
                in steel, lightweight alloy or special composites.
              </strong>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm" data-id="element-1383">
              <p data-id="element-1384">
                <strong data-id="element-1385">Travels (X,Y,Z):</strong> 78.75" x 98.43" x
                31.5"/(39.37" opt.)
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1386">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Matrix%20E1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1387">
              <span className="mr-2" data-id="element-1388">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/breton-matrix-e1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1389">
              <span className="mr-2" data-id="element-1390">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}